import React from 'react'
import _ from 'lodash'
import { statusCodeToText } from '../../utils/diamond'

import styles from './StatusBadge.module.css'

function getClassName(status) {
  const className = styles[`status${_.capitalize(status.replace(/:/, ''))}`]
  return `badge ${styles.statusBadge} ${className}`
}

function getText(status) {
  return status.replace(/:.*$/, '')
}

export function createStatusBadgeString(status) {
  if (status == null) return ''
  if (_.isNumber(status)) {
    status = statusCodeToText(status)
  }
  if (!status) return ''
  return `<span class='${getClassName(status)}'>${getText(status)}</span>`
}

export default ({ status, className }) => {
  if (_.isNumber(status)) {
    status = statusCodeToText(status)
  }
  return (
    <span className={`${getClassName(status)} ${className}`}>
      {getText(status)}
    </span>
  )
}
